export default "__VITE_ASSET__9ae27885__"